import React from "react";
import { IoCloseOutline } from "react-icons/io5";
import { MdOutlineCheck } from "react-icons/md";
import useHeaderDataStatus from "../../../../components/hooks/useHeaderDataStatus";
import WrapperLoader from "../../../../components/spinner/WrapperLoader";

function TransformScript({ scriptPresentData, scriptPresentDataIsLoading }) {
  const isTransformScriptFound =
    scriptPresentData?.files?.["data_transformation.py"]?.file_name;
  return (
    <div
      title={!isTransformScriptFound && "Script is missing"}
      className={
        scriptPresentDataIsLoading
          ? "text-gray-400"
          : !isTransformScriptFound && "text-red-400"
      }
    >
      Transform Script
      <WrapperLoader isLoading={scriptPresentDataIsLoading}></WrapperLoader>
      {/* <div className="flex justify-center">
        <WrapperLoader isLoading={scriptPresentDataIsLoading}>
          {isTransformScriptFound ? (
            <MdOutlineCheck color="green" size={16} />
          ) : (
            <IoCloseOutline color="red" size={16} />
          )}
        </WrapperLoader>
      </div> */}
    </div>
  );
}

export default TransformScript;
